import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormControl} from "react-bootstrap";

export default function VulneracionBusqueda({ 
	register, setValue, getValues, user, personas = [], errors = {}, useAuth, apiService, Cargando, setCargando, idCabezaFamilia, token, Mensaje 
}) {
	const [estadosBusqueda, setEstadosBusqueda] = React.useState([]);
	const [fuentesInformacion, setFuentesInformacion] = React.useState([]);
	const [modalidadesDesaparicion, setModalidadesDesaparicion] = React.useState([]);
	const [posiblesCausas, setPosiblesCausas] = React.useState([]);
	const [busquedarutaposthallazgo, setBusquedarutaposthallazgo] = React.useState([]);
	const [busquedainstireceptora, setBusquedainstireceptora] = React.useState([]);
	const [busquedagarantiassalidacampo, setBusquedagarantiassalidacampo] = React.useState([]);
	const [busquedatipofirmaecard, setBusquedatipofirmaecard] = React.useState([]);
	const [busquedaconsumospa, setBusquedaconsumospa] = React.useState([]);
	const [busquedaredsocial, setBusquedaredsocial] = React.useState([]);
	const [busquedaamenazaprevio, setBusquedaamenazaprevio] = React.useState([]);
	const [busquedaestatura, setBusquedaestatura] = React.useState([]);
	const [busquedacolorcabello, setBusquedacolorcabello] = React.useState([]);
	const [busquedatipocabello, setBusquedatipocabello] = React.useState([]);
	const [busquedatonopiel, setBusquedatonopiel] = React.useState([]);
	const [busquedaparticularesvisibles, setBusquedaparticularesvisibles] = React.useState([]);
	const [busquedaperfilaltoriesgo, setBusquedaperfilaltoriesgo] = React.useState([]);
	const ObtenerDatosSelects = async () => {
		let url = `/ddhh/vulneraciones/obtenerdatosselectsbusqueda`;
		try {
			setCargando(true);
			const response = await apiService.get(url, token);
			const result = await response.data;
			setEstadosBusqueda(result.EstadosBusqueda ?? []);
			setFuentesInformacion(result.FuentesInformacion ?? []);
			setModalidadesDesaparicion(result.ModalidadesDesaparicion ?? []);
			setPosiblesCausas(result.PosiblesCausas ?? []);
			setBusquedarutaposthallazgo(result.Busquedarutaposthallazgo ?? []);
			setBusquedainstireceptora(result.Busquedainstireceptora ?? []);
			setBusquedagarantiassalidacampo(result.Busquedagarantiassalidacampo ?? []);
			setBusquedatipofirmaecard(result.Busquedatipofirmaecard ?? []);
			setBusquedaconsumospa(result.Busquedaconsumospa ?? []);
			setBusquedaredsocial(result.Busquedaredsocial ?? []);
			setBusquedaamenazaprevio(result.Busquedaamenazaprevio ?? []);
			setBusquedaestatura(result.Busquedaestatura ?? []);
			setBusquedacolorcabello(result.Busquedacolorcabello ?? []);
			setBusquedatipocabello(result.Busquedatipocabello ?? []);
			setBusquedatonopiel(result.Busquedatonopiel ?? []);
			setBusquedaparticularesvisibles(result.Busquedaparticularesvisibles ?? []);
			setBusquedaperfilaltoriesgo(result.Busquedaperfilaltoriesgo ?? []);
		} catch (error) {
			console.error('Error fetching data:', error);
		} finally {
			setCargando(false);
		}
	}

	const normalizarSelectValue = (fieldName) => {
		const currentValue = getValues?.(fieldName);
		const normalizedValue = currentValue && typeof currentValue === 'object'
			? (currentValue.id ?? currentValue.value ?? '')
			: currentValue;

		if (normalizedValue === '' || normalizedValue == null) {
			return;
		}

		setValue(fieldName, String(normalizedValue), {
			shouldValidate: true,
			shouldDirty: false,
		});
	};
	
	useEffect(() => {
		setValue('datosVulneracion.intUsrid', user);
	}, [setValue, user]);

	useEffect(() => {
		if (
			estadosBusqueda.length === 0 &&
			fuentesInformacion.length === 0 &&
			modalidadesDesaparicion.length === 0 &&
			posiblesCausas.length === 0 &&
			busquedarutaposthallazgo.length === 0 &&
			busquedainstireceptora.length === 0 &&
			busquedagarantiassalidacampo.length === 0 &&
			busquedatipofirmaecard.length === 0 &&
			busquedaconsumospa.length === 0 &&
			busquedaredsocial.length === 0 &&
			busquedaamenazaprevio.length === 0 &&
			busquedaestatura.length === 0 &&
			busquedacolorcabello.length === 0 &&
			busquedatipocabello.length === 0 &&
			busquedatonopiel.length === 0 &&
			busquedaparticularesvisibles.length === 0 &&
			busquedaperfilaltoriesgo.length === 0
		) {
			return;
		}

		[
			'datosVulneracion.intIdfuenteinformacion',
			'datosVulneracion.intIdmodalidaddesaparicion',
			'datosVulneracion.intIdposiblecausa',
			'datosVulneracion.intIdestadobusqueda',
			'datosVulneracion.intIdbusquedaestatura',
			'datosVulneracion.intIdbusquedacolorcabello',
			'datosVulneracion.intIdbusquedatipocabello',
			'datosVulneracion.intIdbusquedatonopiel',
			'datosVulneracion.intIdbusquedaparticularesvisibles',
			'datosVulneracion.intIdbusquedaperfilaltoriesgo',
			'datosVulneracion.intIdbusquedaamenazaprevio',
			'datosVulneracion.intIdbusquedaredsocial',
			'datosVulneracion.intIdbusquedaconsumospa',
			'datosVulneracion.intIdbusquedatipofirmaecard',
			'datosVulneracion.intIdbusquedagarantiasalidacampo',
			'datosVulneracion.intIdbusquedainstreceptora',
			'datosVulneracion.intIdbusquedarutaposthallazgo'
		].forEach(normalizarSelectValue);
	}, [
		estadosBusqueda,
		fuentesInformacion,
		modalidadesDesaparicion,
		posiblesCausas,
		busquedarutaposthallazgo,
		busquedainstireceptora,
		busquedagarantiassalidacampo,
		busquedatipofirmaecard,
		busquedaconsumospa,
		busquedaredsocial,
		busquedaamenazaprevio,
		busquedaestatura,
		busquedacolorcabello,
		busquedatipocabello,
		busquedatonopiel,
		busquedaparticularesvisibles,
		busquedaperfilaltoriesgo,
		getValues,
		setValue
	]);

	useEffect(() => {
		ObtenerDatosSelects();
	}, []);
	return (
		<div className="card">
			<div className="card-header">
				<div className="col-md-12">
					<h6 className="text-primary font-weight-bold mb-3">Datos de Busqueda</h6>
				</div>
			</div>
			<div className="card-body">
				<div className="row">
					<div className="col-md-4">
						<div className="form-group">
							<label htmlFor="datosVulneracion.strNumeroradicado">N&uacute;mero de radicado (Incidente)</label>
							<input
								type="text"
								id="datosVulneracion.strNumeroradicado"
								className="form-control"
								{...register('datosVulneracion.strNumeroradicado', { required: true })}
								placeholder="Ej: 12345"
							/>
							{errors.datosVulneracion?.strNumeroradicado && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
					<div className="col-md-4">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intIdfuenteinformacion">Persona, dependencia u organizaci&oacute;n que reporta el caso</label>
							<select id="datosVulneracion.intIdfuenteinformacion" className="form-control" {...register('datosVulneracion.intIdfuenteinformacion' , { required: true })}>
                                <option value="">Seleccione...</option>
                                {fuentesInformacion.map((option, idx) => (
									<option key={option.id} value={option.id}>
										{option.str_nombre}
									</option>
								))}
                            </select>
                            {errors.datosVulneracion?.intIdfuenteinformacion && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
					<div className="col-md-4">
						<div className="form-group">
							<label htmlFor="datosVulneracion.strCualfuenteinformacion">Cual fuente de informaci&oacute;n</label>
							<input
								type="text"
								id="datosVulneracion.strCualfuenteinformacion"
								className="form-control"
								{...register('datosVulneracion.strCualfuenteinformacion', { required: true })}
								placeholder="Ej: Nombre de la persona, dependencia u organización"
							/>
							{errors.datosVulneracion?.strCualfuenteinformacion && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intIdmodalidaddesaparicion">Modalidad desaparicion</label>
							<select id="datosVulneracion.intIdmodalidaddesaparicion" className="form-control" {...register('datosVulneracion.intIdmodalidaddesaparicion' , { required: true })}>
                                <option value="">Seleccione...</option>
                                {modalidadesDesaparicion.map((option, idx) => (
									<option key={option.id} value={option.id}>
										{option.str_nombre}
									</option>
								))}
                            </select>
                            {errors.datosVulneracion?.intIdmodalidaddesaparicion && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intIdposiblecausa">Posible causa de la desaparici&oacute;n</label>
							<select id="datosVulneracion.intIdposiblecausa" className="form-control" {...register('datosVulneracion.intIdposiblecausa' , { required: true })}>
                                <option value="">Seleccione...</option>
                                {posiblesCausas.map((option, idx) => (
									<option key={option.id} value={option.id}>
										{option.str_nombre}
									</option>
								))}
                            </select>
                            {errors.datosVulneracion?.intIdposiblecausa && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intIdestadobusqueda">Estado de busqueda</label>
							<select id="datosVulneracion.intIdestadobusqueda" className="form-control" {...register('datosVulneracion.intIdestadobusqueda' , { required: true })}>
                                <option value="">Seleccione...</option>
                                {estadosBusqueda.map((option, idx) => (
									<option key={option.id} value={option.id}>
										{option.str_nombre}
									</option>
								))}
                            </select>
                            {errors.datosVulneracion?.intIdestadobusqueda && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.bolPiezacomunicacional">Pieza comunicacional</label>
							<select
								id="datosVulneracion.bolPiezacomunicacional"
								className="form-control"
								{...register('datosVulneracion.bolPiezacomunicacional', {
									setValueAs: (value) => {
										if (value === '') return null;
										return value === 'true';
									}
								})}
							>
								<option value="">Seleccione...</option>
								<option value="true">SI</option>
								<option value="false">NO</option>
							</select>
							{errors.datosVulneracion?.bolPiezacomunicacional && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-md-6">
						<div className="form-group">
							<label htmlFor="datosVulneracion.strInstitucionreportainfo">Institucion que reporta info</label>
							<input
								type="text"
								maxLength={120}
								id="datosVulneracion.strInstitucionreportainfo"
								className="form-control"
								{...register('datosVulneracion.strInstitucionreportainfo', { required: true })}
							/>
							{errors.datosVulneracion?.strInstitucionreportainfo && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
					<div className="col-md-6">
						<div className="form-group">
							<label htmlFor="datosVulneracion.strLugaraparicion">Lugar de aparici&oacute;n</label>
							<input
								type="text"
								maxLength={250}
								id="datosVulneracion.strLugaraparicion"
								className="form-control"
								{...register('datosVulneracion.strLugaraparicion', { required: true })}
							/>
							{errors.datosVulneracion?.strLugaraparicion && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intIdbusquedaestatura">Estatura aproximada: rango en metros </label>
							<select
								id="datosVulneracion.intIdbusquedaestatura"
								className="form-control"
								{...register('datosVulneracion.intIdbusquedaestatura', { valueAsNumber: true })}
							>
								<option value="">Seleccione...</option>
								{busquedaestatura.map((estatura) => (
									<option key={estatura.id} value={estatura.id}>
										{estatura.strNombre}
									</option>
								))}
							</select>
						</div>
					</div>
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intIdbusquedacolorcabello">Color de cabello</label>
							<select
								id="datosVulneracion.intIdbusquedacolorcabello"
								className="form-control"
								{...register('datosVulneracion.intIdbusquedacolorcabello', { valueAsNumber: true })}
							>
								<option value="">Seleccione...</option>
								{busquedacolorcabello.map((color) => (
									<option key={color.id} value={color.id}>
										{color.strNombre}
									</option>
								))}
							</select>
						</div>
					</div>
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intIdbusquedatipocabello">Tipo de cabello</label>
							<select
								id="datosVulneracion.intIdbusquedatipocabello"
								className="form-control"
								{...register('datosVulneracion.intIdbusquedatipocabello', { valueAsNumber: true })}
							>
								<option value="">Seleccione...</option>
								{busquedatipocabello.map((tipo) => (
									<option key={tipo.id} value={tipo.id}>
										{tipo.strNombre}
									</option>
								))}
							</select>
						</div>
					</div>
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intIdbusquedatonopiel">Tono de piel</label>
							<select
								id="datosVulneracion.intIdbusquedatonopiel"
								className="form-control"
								{...register('datosVulneracion.intIdbusquedatonopiel', { valueAsNumber: true })}
							>
								<option value="">Seleccione...</option>
								{busquedatonopiel.map((tono) => (
									<option key={tono.id} value={tono.id}>
										{tono.strNombre}
									</option>
								))}
							</select>
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intIdbusquedaparticularesvisibles">Señales particulares visibles</label>
							<select
								id="datosVulneracion.intIdbusquedaparticularesvisibles"
								className="form-control"
								{...register('datosVulneracion.intIdbusquedaparticularesvisibles', { valueAsNumber: true })}
							>
								<option value="">Seleccione...</option>
								{busquedaparticularesvisibles.map((particular) => (
									<option key={particular.id} value={particular.id}>
										{particular.strNombre}
									</option>
								))}
							</select>
						</div>
					</div>
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.strDescripcionvestimenta">Prenda de vestir en el momento del hecho. (descripci&oacute;n detallada de los accesorios que llevaba antes del hecho)</label>
							<input
								type="text"
								id="datosVulneracion.strDescripcionvestimenta"
								className="form-control"
								{...register('datosVulneracion.strDescripcionvestimenta')}
							/>
						</div>
					</div>
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intIdbusquedaperfilaltoriesgo">Perfil o rol de alto riesgo</label>
							<select
								id="datosVulneracion.intIdbusquedaperfilaltoriesgo"
								className="form-control"
								{...register('datosVulneracion.intIdbusquedaperfilaltoriesgo', { valueAsNumber: true })}
							>
								<option value="">Seleccione...</option>
								{busquedaperfilaltoriesgo.map((perfil) => (
									<option key={perfil.id} value={perfil.id}>
										{perfil.strNombre}
									</option>
								))}
							</select>
						</div>
					</div>
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intIdbusquedaamenazaprevio">Presencia de amenazas previas</label>
							<select
								id="datosVulneracion.intIdbusquedaamenazaprevio"
								className="form-control"
								{...register('datosVulneracion.intIdbusquedaamenazaprevio', { valueAsNumber: true })}
							>
								<option value="">Seleccione...</option>
								{busquedaamenazaprevio.map((amenaza) => (
									<option key={amenaza.id} value={amenaza.id}>
										{amenaza.strNombre}
									</option>
								))}
							</select>
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intIdbusquedaredsocial">Redes sociales de la v&iacute;ctima (perfiles activos)</label>
							<select
								id="datosVulneracion.intIdbusquedaredsocial"
								className="form-control"
								{...register('datosVulneracion.intIdbusquedaredsocial', { valueAsNumber: true })}
							>
								<option value="">Seleccione...</option>
								{busquedaredsocial.map((red) => (
									<option key={red.id} value={red.id}>
										{red.strNombre}
									</option>
								))}
							</select>
						</div>
					</div>
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intIdbusquedaconsumospa">Consumo/dependencia de sustancias (SPA) o medicamentos</label>
							<select
								id="datosVulneracion.intIdbusquedaconsumospa"
								className="form-control"
								{...register('datosVulneracion.intIdbusquedaconsumospa', { valueAsNumber: true })}
							>
								<option value="">Seleccione...</option>
								{busquedaconsumospa.map((consumo) => (
									<option key={consumo.id} value={consumo.id}>
										{consumo.strNombre}
									</option>
								))}
							</select>
						</div>
					</div>
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.timHorareporte">Hora del reporte e inicio de activaci&oacute;n</label>
							<FormControl
								type="time"
								id="datosVulneracion.timHorareporte"
								className="form-control"
								{...register('datosVulneracion.timHorareporte')}
							/>
						</div>
					</div>
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.strGeoreferenciacion">Georreferenciaci&oacute;n del &uacute;ltimo punto visto (coordenadas GPS o dirección exacta)</label>
							<input
								type="text"
								id="datosVulneracion.strGeoreferenciacion"
								className="form-control"
								{...register('datosVulneracion.strGeoreferenciacion')}
							/>
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intIdbusquedatipofirmaecard">Automatizaci&oacute;n firmada para difusi&oacute;n e-card</label>
							<select
								id="datosVulneracion.intIdbusquedatipofirmaecard"
								className="form-control"
								{...register('datosVulneracion.intIdbusquedatipofirmaecard', { valueAsNumber: true })}
							>
								<option value="">Seleccione...</option>
								{busquedatipofirmaecard.map((tipo) => (
									<option key={tipo.id} value={tipo.id}>
										{tipo.strNombre}
									</option>
								))}
							</select>
						</div>
					</div>
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intIdbusquedagarantiasalidacampo">Garant&iacute;as de seguridad para salida de campo</label>
							<select
								id="datosVulneracion.intIdbusquedagarantiasalidacampo"
								className="form-control"
								{...register('datosVulneracion.intIdbusquedagarantiasalidacampo', { valueAsNumber: true })}
							>
								<option value="">Seleccione...</option>
								{busquedagarantiassalidacampo.map((garantia) => (
									<option key={garantia.id} value={garantia.id}>
										{garantia.strNombre}
									</option>
								))}
							</select>
						</div>
					</div>
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intIdbusquedainstreceptora">Instituci&oacute;n receptora al hallazgo (si aplica)</label>
							<select
								id="datosVulneracion.intIdbusquedainstreceptora"
								className="form-control"
								{...register('datosVulneracion.intIdbusquedainstreceptora', { valueAsNumber: true })}
							>
								<option value="">Seleccione...</option>
								{busquedainstireceptora.map((inst) => (
									<option key={inst.id} value={inst.id}>
										{inst.strNombre}
									</option>
								))}
							</select>
						</div>
					</div>
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intIdbusquedarutaposthallazgo">Ruta interdisciplinaria de derivación post-hallazgo</label>
							<select
								id="datosVulneracion.intIdbusquedarutaposthallazgo"
								className="form-control"
								{...register('datosVulneracion.intIdbusquedarutaposthallazgo', { valueAsNumber: true })}
							>
								<option value="">Seleccione...</option>
								{busquedarutaposthallazgo.map((ruta) => (
									<option key={ruta.id} value={ruta.id}>
										{ruta.strNombre}
									</option>
								))}
							</select>
						</div>
					</div>
				</div>
				<input type="hidden" {...register('datosVulneracion.intUsrid', { valueAsNumber: true })} />
			</div>
		</div>
	);
}

VulneracionBusqueda.propTypes = {
	errors: PropTypes.object,
	personas: PropTypes.array,
	getValues: PropTypes.func,
	register: PropTypes.func.isRequired,
	setValue: PropTypes.func.isRequired,
	user: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
